import moment from "moment/moment";
import ApiService from "./ApiService";
import axios from "axios";
export default class GeneralServices {
  constructor() {}

  async authorizationApi() {
    const api = new ApiService();
    const response = await api
      .get("authorization")
      .then((response) => {
        if (response.access_token) {
          localStorage.setItem("token", response.access_token);
          localStorage.setItem(
            "expires_token",
            moment().add(15, "minutes").format("YYYY-MM-DD HH:mm:ss")
          );
        } else {
          this.$toast.error("Ocorreu um erro na comunicacao!");
        }
      })
      .catch(() => {
        localStorage.setItem("apiErrorDescription", "Erro na autenticação!");
      });
  }

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  validateCPF(cpf) {
    cpf = cpf.replace(/\D/g, "");
    var Soma;
    var Resto;
    Soma = 0;
    if (cpf == "00000000000") return false;

    for (let i = 1; i <= 9; i++)
      Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(cpf.substring(9, 10))) return false;
    Soma = 0;
    for (let i = 1; i <= 10; i++)
      Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(cpf.substring(10, 11))) return false;
    return true;
  }

  validateCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (
      cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999"
    )
      return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;

    return true;
  }

  validateVigency(vigency) {
    const split = vigency?.split("/");

    if (split?.length == 3 && vigency) {
      const date = new Date(
        parseInt(split[2]),
        parseInt(split[1]) - 1,
        parseInt(split[0])
      );

      const dateAfter35Days = moment().add(35, "days").format("YYYY-MM-DD");

      const dateMoment = moment(date);

      if (dateMoment.isAfter(dateAfter35Days)) {
        return false;
      }
      return true;
    }
  }

  validateDate(date) {
    const split = date?.split("/");

    if (split?.length == 3 && date) {
      const date = new Date(
        parseInt(split[2]),
        parseInt(split[1]) - 1,
        parseInt(split[0])
      );

      const dateMoment = moment(date);

      if (dateMoment.isValid()) {
        return true;
      }
      return false;
    }
  }

  async saveSessionInfo(data) {
    try {
      const clickId = localStorage.getItem("sessionId");
      const url = "https://globusesteiraback.azurewebsites.net/api/";
        // const url = "http://localhost:3007/api/"
      await axios.post(
        `${url}loja/set-info-session?clickId=${clickId}`,
        data
      );
    } catch (error) {
      console.log(error);
    }
  }
}
